module.exports = __webpack_public_path__ + "media/images/icon_calender-f620392344c0cb619bd66753f3a12ac3.svg";